module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/faceting/faceting.component.css
// module id = ./src/app/examples/faceting/faceting.component.css
// module chunks = main